<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>{{ title }}</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="
                  text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                  text-center
                "
              >
                Clase
              </th>
              <th
                class="
                  text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                  ps-2
                "
              >
                Descripción
              </th>
              <th
                class="
                  text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  opacity-7
                  ps-2
                "
              >
                Tarifa
              </th>
              <th
                class="
                  text-uppercase text-secondary text-xxs
                  font-weight-bolder
                  text-center
                  opacity-7
                  ps-2
                "
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody v-if="itemsList.length !== 0">
            <tr v-for="item in itemsList" :key="item.id">
              <td>
                <!-- <div class="d-flex px-2"> -->
                <!-- <div>
                    <img
                      src="../../assets/img/small-logos/logo-spotify.svg"
                      class="avatar avatar-sm rounded-circle me-2"
                      alt="spotify"
                    />
                  </div> -->
                <div class="my-auto text-center">
                  <h6 class="mb-0 text-sm">{{ item.kind }}</h6>
                </div>
                <!-- </div> -->
              </td>
              <td>
                <span class="text-xs font-weight-bold">{{
                  item.description
                }}</span>
              </td>
              <td>
                <span class="text-sm font-weight-bold mb-0"
                  >${{ item.price }}</span
                >
              </td>
              <td class="align-middle">
                <div class="text-center">
                  <button
                    @click="showAlert(item.id)"
                    class="btn btn-link text-danger text-gradient px-3 mb-0"
                  >
                    <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                    Eliminar
                  </button>
                  <router-link
                    :to="`/rate-card/${bypassID}/${item.id.toString()}`"
                    class="btn btn-link text-dark px-3 mb-0"
                  >
                    <i
                      class="fas fa-pencil-alt text-dark me-2"
                      aria-hidden="true"
                    ></i
                    >Editar
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rates-table",
  props: {
    title: {
      type: String,
    },
    bypassID: {
      type: String,
      request: true,
    },
    itemsList: {
      type: Array,
      request: true,
    },
  },
  methods: {
    deleteRate(rateID) {
      this.plain
        .delete(`/rates/${rateID}`)
        .then(() => {
          this.$parent.deleteItemRates(rateID)
          // console.log("TARIFA eliminada correctamente");
          // console.log(response.data);
        })
        .catch((error) => {
          console.log("Error al eliminar TARIFAS", error);
        });
    },
    showAlert(rateID) {
      //deleteUser(user.id)
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteRate(rateID);
          this.$swal.fire(
            '¡Eliminado!',
            'El Usuario ha sido eliminado.',
          )
        }
      })
    }
  },
};
</script>
